export { default } from "./SkeletonText";